import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-93e9ea78"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home pageBox"
};
const _hoisted_2 = {
  class: "pageContainer"
};
const _hoisted_3 = {
  class: "box van-hairline--top"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "DeFi Signal subscription", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "recurring"
}, "Recurring", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "price"
}, "$9 USD/month", -1));
const _hoisted_7 = {
  class: "bottomBox"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_row, {
    class: "titleBar",
    justify: "space-between",
    align: "center"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_col, null, {
      default: _withCtx(() => [_hoisted_4]),
      _: 1
    }), _createVNode(_component_van_col, {
      span: "12",
      class: "rightPrice"
    }, {
      default: _withCtx(() => [_hoisted_5, _hoisted_6]),
      _: 1
    })]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_button, {
    block: "",
    type: "primary",
    disabled: ""
  }, {
    default: _withCtx(() => [_createTextVNode("Cancel")]),
    _: 1
  })])]);
}